import { render, staticRenderFns } from "./FactsPage.vue?vue&type=template&id=2dcb8231&"
import script from "./FactsPage.vue?vue&type=script&lang=js&"
export * from "./FactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports